import React from 'react'
import { useIntl } from 'react-intl'
import { Select } from 'mailup-web-components'
import PropTypes from 'prop-types'

const FontWeightSelect = ({ value, onChange, disabled }) => {
  const intl = useIntl()
  const fontWeightOptions = [
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.TextNormal'
      }),
      value: 400
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentDefaults.TextBold'
      }),
      value: 700
    }
  ]
  return (
    <Select
      options={fontWeightOptions}
      value={value}
      onChange={onChange}
      searchable={false}
      disabled={disabled}
    />
  )
}

export default FontWeightSelect

FontWeightSelect.propTypes = {
  value: PropTypes.num,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
}
